import InputSelect from './InputSelect';
export default InputSelect;



// WEBPACK FOOTER //
// ./src/components/shared/InputSelect/index.js